module.exports = __webpack_public_path__ + "static/2-7f7b74b9695017ee60baf0037cab081c.jpeg";